const GiftVoucherDeliveryTypeEnum = require('@/lib/GiftVouchers/GiftVoucherDeliveryTypeEnum');

/**
 * @param {CartLine} cartLine
 * @returns boolean
 */
const productThatCanBeDelivered = (cartLine) => cartLine.getItem().requiresDelivery;

/**
 * @param {CartLine} cartLine
 * @returns boolean
 */
const voucherRequiringDelivery = (cartLine) => cartLine.soldGiftVoucherData
        && cartLine.soldGiftVoucherData.deliveryType === GiftVoucherDeliveryTypeEnum.POST;

/**
 * Whether there is an item in our cart that *can* (not *must*) be delivered.
 *
 * @param {CartLine[]} cartLines
 * @returns boolean
 */
const containsDeliverableItem = (cartLines) => (
    !!cartLines.find(productThatCanBeDelivered) || !!cartLines.find(voucherRequiringDelivery)
);

/**
 * Whether there is an item in our cart that *must* be delivered.
 *
 * @param {CartLine[]} cartLines
 * @returns boolean
 */
const containsItemRequiringDelivery = (cartLines) => (
    !!cartLines.find(voucherRequiringDelivery)
);

module.exports = {
    containsDeliverableItem,
    containsItemRequiringDelivery,
};
